<template>
  <div class="recordBox">
    <div v-show="!isShowArticle" class="recordBoxIn">
      <div class="popHeader">
        <span class="title">记录</span>
        <i class="iconfont icon-guanbi closeIcon" @click="closePop" />
      </div>
      <!-- 小程序 -->
      <div class="contentBox">
        <div class="data_row" v-loading="articleLoadIng" v-if="origin === '公众号'">
          <div class="data_row_left">
            <div class="data_row_col">
              <img
                src="https://baike-med-1256891581.file.myqcloud.com/2021045/57ea8360-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                alt=""
              />
              <span>阅读人数：</span>
              <span class="value">{{ watchData.read_pnt || '-' }}</span>
            </div>
            <div class="data_row_col">
              <img
                src="https://baike-med-1256891581.file.myqcloud.com/2021047/57ed1b70-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                alt=""
              />
              <span>转发：</span>
              <span class="value">{{ watchData.share_count || '-' }}</span>
            </div>
          </div>
          <div class="data_row_right">
            <div class="data_row_col">
              <img
                src="https://baike-med-1256891581.file.myqcloud.com/2021041/57eccd50-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                alt=""
              />
              <span>收藏：</span>
              <span class="value">{{ watchData.collect_count || '-' }}</span>
            </div>
            <div class="data_row_col">
              <img
                src="https://baike-med-1256891581.file.myqcloud.com/2021047/57d94550-9b83-11eb-87f5-87f8260230cc_0.png"
                alt=""
              />
              <span>完成率：</span>
              <span class="value">
                {{ getFinishRate(watchData.finish_rate) }}
              </span>
            </div>
          </div>
        </div>
        <div class="roll_box custom_scroll" v-loading="recordLoading">
          <div class="miniProgram" v-show="origin === '公众号'">
            <h5 class="bigTitle">小程序</h5>
            <div class="recordList">
              <div class="already_publish" v-if="recordData.miniRecode.length">
                <div class="title">
                  <i class="iconfont icon-xuanzhong" />
                  <span>已发布</span>
                </div>
                <div class="item" v-for="(item, index) in recordData.miniRecode" :key="index">
                  <div class="item_top">
                    <span class="item_top_left">
                      <div class="dot"></div>
                      <span>{{ item.article_title }}</span>
                    </span>
                    <span class="see_btn" @click="handleSee(item, 1)">点击查看</span>
                  </div>
                  <div class="describe">
                    {{ item.publish_time | parseTime }}
                    已发布{{ item.app_name }}
                  </div>
                  <div class="statistics">
                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021045/57ea8360-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                      alt=""
                    />
                    <span>{{ item.read_pnt || '0' }}</span>

                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021047/57ed1b70-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                      alt=""
                    />
                    <span>{{ item.share_count || '0' }}</span>
                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021041/57eccd50-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                      alt=""
                    />
                    <span>{{ item.collect_count || '0' }}</span>
                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021047/57d94550-9b83-11eb-87f5-87f8260230cc_0.png"
                      alt=""
                    />
                    <span>
                      {{ getFinishRate(item.finish_rate) }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="no_data">
                <i class="el-icon-time" />
                <span>未发布到小程序</span>
              </div>
            </div>
          </div>
          <div class="miniProgram" v-show="origin === '公众号'">
            <h5 class="bigTitle">公众号</h5>
            <div class="recordList">
              <div class="already_publish" v-if="recordData.wechatRecode.length">
                <div class="title">
                  <i class="el-icon-circle-check" />
                  <span>已发布</span>
                </div>
                <div class="item" v-for="(item, index) in recordData.wechatRecode" :key="index">
                  <div class="item_top">
                    <span class="item_top_left">
                      <div class="dot"></div>
                      <span>{{ item.article_title }}</span>
                    </span>
                    <span class="see_btn" @click="handleSee(item, 0)">点击查看</span>
                  </div>
                  <div class="describe">
                    {{ item.publish_time | parseTime }}
                    已发布{{ item.app_name }}
                  </div>
                  <div class="describe">
                    策略/名单名称：{{ item.strategy_roster_name }} | 发送人数：{{
                      item.send_count
                    }}人
                  </div>
                  <div class="statistics">
                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021045/57ea8360-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                      alt=""
                    />
                    <span>{{ item.read_pnt || '0' }}</span>
                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021047/57ed1b70-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                      alt=""
                    />
                    <span>{{ item.share_count || '0' }}</span>

                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021041/57eccd50-9b83-11eb-ae0e-21d0e54b35ac_0.png"
                      alt=""
                    />
                    <span>{{ item.collect_count || '0' }}</span>
                    <img
                      src="https://baike-med-1256891581.file.myqcloud.com/2021047/57d94550-9b83-11eb-87f5-87f8260230cc_0.png"
                      alt=""
                    />
                    <span>
                      {{ getFinishRate(item.finish_rate) }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="no_data">
                <i class="el-icon-time" />
                <span>未发布到公众号</span>
              </div>
            </div>
          </div>
          <div class="miniProgram" v-show="origin === '企业微信'">
            <h5 class="bigTitle">企业微信</h5>
            <div class="recordList">
              <div class="already_publish" v-if="recordData.wxRecode.length">
                <div class="title">
                  <i class="el-icon-circle-check" />
                  <span>已发布</span>
                </div>
                <div class="item" v-for="(item, index) in recordData.wxRecode" :key="index">
                  <div class="item_top">
                    <span class="item_top_left">
                      <div class="dot"></div>
                      <span>{{ item.article_title }}</span>
                    </span>
                    <span class="see_btn" @click="handleSee(item, 2)">点击查看</span>
                  </div>
                  <div class="describe">
                    {{ item.publish_time | parseTime }}
                    已发布{{ item.app_name }}
                  </div>
                  <div class="statistics">
                    <span>送达人数:{{ item.delivery_count || '0' }}&nbsp;</span>
                    <span>阅读人数:{{ item.read_pnt || '0' }}&nbsp;</span>
                    <span>阅读次数:{{ item.read_count || '0' }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="no_data">
                <i class="el-icon-time" />
                <span>未发布到企业微信</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lookSnapshoot
      v-if="isShowArticle"
      class="recordBoxIn lookSnapshoot"
      :publish-record-id="publishRecordId"
      :publish-type="publishType"
      @hideShow="hideShow"
      @closePop="closePop"
    />
  </div>
</template>
<script>
import lookSnapshoot from '../lookSnapshoot';
import { listPublishRecodeApi, getArticleStatByArtIDApi } from '@/api/releaseManagement';

export default {
  name: 'RecordPop',
  components: {
    lookSnapshoot,
  },
  props: {
    artId: {
      type: [String, Number],
      default: null,
    },
    origin: {
      type: String, // 公众号/企业微信
      default: '',
    },
  },
  data() {
    return {
      // 发布数据
      recordData: {
        // enterpriseWx: [], // 企业微信数据
        miniRecode: [], // 小程序数据
        wechatRecode: [], // 公众号数据
        wxRecode: [], // 企业微信数据
      },
      watchData: {
        read_pnt: null, // 阅读人数
        share_count: null, // 分享次数
        collect_count: null, // 收藏次数
        finish_rate: null, // 完成率
      },
      isShowArticle: false /* 公众号发布完成 */,
      publishRecordId: '' /* 详情页面ID */,
      publishType: 0, // 详情页面类型，0为公众号，1为小程序，2为企业微信
      articleLoadIng: false,
      recordLoading: false,
    };
  },
  computed: {
    getFinishRate() {
      return (finishRate) => {
        if (finishRate) {
          return isNaN(Number(finishRate)) ? '-' : `${Number(finishRate).toFixed(2)} %`;
        }
        return '-';
      };
    },
  },
  mounted() {
    this.getArticleStatDetail();
    this.listPublishRecode();
    // this.recordData = recordData;  // testmock
  },
  methods: {
    getArticleStatDetail() {
      this.articleLoadIng = true;
      getArticleStatByArtIDApi({
        art_id: this.artId,
      })
        .then((res) => {
          this.articleLoadIng = false;
          this.watchData = res;
        })
        .catch((e) => {
          this.articleLoadIng = false;
          this.$message.error(e.message);
        });
    },
    handleSee(row, type) {
      if (row.id !== undefined) {
        this.isShowArticle = true;
        if (type === 2) {
          this.publishRecordId = row.push_id;
        } else {
          this.publishRecordId = row.id;
        }
        this.publishType = type;
      } else {
        this.publishRecordId = '';
        this.$message('暂无文章快照数据');
      }
    },
    closePop() {
      this.$emit('closeRecord');
    },
    listPublishRecode() {
      this.recordLoading = true;
      listPublishRecodeApi({
        art_id: this.artId,
        pushType: this.origin === '公众号' ? 0 : 1,
      })
        .then((res) => {
          console.log(res);
          const { miniRecode, wechatRecode, wxRecode } = res;
          if (miniRecode && wechatRecode && wxRecode) {
            this.recordLoading = false;
            this.recordData = res;
            for (const item of this.recordData.wechatRecode) {
              if (isNaN(Number(item.finish_rate))) {
                item.finish_rate = false;
              } else {
                item.finish_rate = `${Number(item.finish_rate).toFixed(2)} %`;
              }
            }
          } else {
            this.$message.error(
              `获取数据出错，listPublishRecodeApi中的${miniRecode ? 'miniRecode,' : ''}${
                wechatRecode ? 'wechatRecode,' : ''
              }${wxRecode ? 'wxRecode,' : ''}为空`,
            );
          }
        })
        .catch(() => {
          this.recordLoading = false;
        });
    },
    hideShow() {
      this.isShowArticle = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
